import React, { useEffect, useState } from "react";
import Chart from "./Chart";
import { Radio, Select } from "antd";
import Server from "./../../Server.js";
import { Card, Space } from 'antd';
import moment from 'moment-jalaali';
import { Spin } from 'antd';

function ChartCard(props) {
  const [time, SetTime] = useState("week");
  const [options, setOptions] = useState(props.options);
  const [loading, setLoading] = useState(true);

  const myServer = new Server();
  useEffect(() => {
    getWidget(time);
  }, []);
  const getWidget = (newTime) =>{
    setLoading(true);

    const date = moment();
    let firstFilterTime = "";
    let lastFilterTime = "";
    if(newTime === "today"){
      firstFilterTime = date.locale('fa').format("jYYYY/jM/jD");
      lastFilterTime = date.locale('fa').format("jYYYY/jM/jD");
    }
    if(newTime === "yesterday"){
      firstFilterTime = date.subtract(1, 'days').locale('fa').format("jYYYY/jM/jD");
      lastFilterTime = firstFilterTime;
    }
    if(newTime === "week"){
      lastFilterTime = date.locale('fa').format("jYYYY/jM/jD");
      firstFilterTime = date.subtract(7, 'days').locale('fa').format("jYYYY/jM/jD");
    }  
    if(newTime === "mounth"){
      lastFilterTime = date.locale('fa').format("jYYYY/jM/jD");
      firstFilterTime = date.subtract(30, 'days').locale('fa').format("jYYYY/jM/jD");
    }
    if(newTime === "year"){
      lastFilterTime = date.locale('fa').format("jYYYY/jM/jD");
      firstFilterTime = date.subtract(365, 'days').locale('fa').format("jYYYY/jM/jD");
    }
    if(newTime === "all"){
      firstFilterTime = "1300/1/1";
      lastFilterTime = date.locale('fa').format("jYYYY/jM/jD");
    }
   
    let param = {
      token: localStorage.getItem("api_token"),
      fromDate: firstFilterTime,
      UntilDate: lastFilterTime,
    };
    let SCallBack = (response) => {
      const categories = [];
      const data = [];
      options["colors"] = ["#395cad","#8b8484", "#d57979", "#7b1313", "#2c91a3", "#0089a1", "#45b10f", "#dbb132"];
      if(options.chart.type == "column" || options.chart.type == "line" ){
        if(response.data.sum !== undefined){
          options["subtitle"] = {
            text: `مجموع: ${response.data.sum.toString()
              .replace(/,/g, "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}  ریال`
          }
        }
        response.data.result.map((item) => {
          categories.push(item.name);
          data.push(item.value);
        });
        options["xAxis"] = {
          categories: categories,
          title: "ریال",
        };
        options["yAxis"] = {
          title: "ریال",
          labels: {
            formatter: function(){
              return   this.value.toString().replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
          }
        };
      }
      if(options.chart.type == "pie"){
        response.data.result.map((item) => {
          data.push({
            name: item.name,
            y: item.y
          });
        });
      }
      options["series"] = [
        {
          data: data,
          name: ""
        },
      ];
      setLoading(false);
      setOptions(options);
    };
    let ECallBack = (error) => {
      console.log(error);
    };
    myServer.send(`AdminApi/${props.method}`, param, SCallBack, ECallBack);
  }
  return (
    <Card style={{minHeight:400}}>
      {props.timeFilter &&
        <div>
          <Radio.Group
            value={time}
            onChange={(e) => {
              SetTime(e.target.value);
              getWidget(e.target.value)
            }}
          >
            {props.timeFilter.today &&
               <Radio.Button value="today">امروز</Radio.Button>
            }
            {props.timeFilter.yesterday &&
            <Radio.Button value="yesterday">دیروز</Radio.Button>
          }
            {props.timeFilter.week &&
            <Radio.Button value="week">یک هفته پیش</Radio.Button>
          }
            {props.timeFilter.mounth &&
             <Radio.Button value="mounth">یک ماه پیش</Radio.Button>
            }
            {/*<Radio.Button value="year">یک سال پیش</Radio.Button>
            <Radio.Button value="all">از ابتدا</Radio.Button> */}
          </Radio.Group>
        </div>
      }
      {loading ?
      <div style={{height:400,display:'flex',justifyContent:'center',alignItems:'center',width:'100%'}} >
      <Spin />
      </div> :
      <Chart options={options} />}
      
    </Card>
  );
}

export default ChartCard;
